import { cop31NotePath, getCop31Note } from "@/lib/cop31-notes";
import redirects from "./redirects.json";
import legacyArticles from "./legacy-articles.json";

/** Exact section/book aliases checked at the request boundary, before routing. */
export function legacyPathRedirect(pathname: string): { to_url: string; status: 301 } | null {
  const entry = redirects.find((row) => row.from_path === (pathname.replace(/\/+$/, "") || "/"));
  return entry ? { to_url: entry.to_url, status: 301 } : null;
}

/** Frozen, user-authorized list; no runtime inference or unknown-path capture. */
export function legacyArticleEntry(pathname: string) {
  const match = /^\/(?:yazilar|essays)\/([^/]+)$/.exec(pathname.replace(/\/+$/, ""));
  return match ? legacyArticles.find((entry) => entry.legacySlug === match[1]) ?? null : null;
}

export function isGoneLegacyPath(pathname: string): boolean {
  const clean = pathname.replace(/\/+$/, "") || "/";
  if (clean === "/en" || clean.startsWith("/en/")) return true;
  if (legacyPathRedirect(clean)) return false;
  const entry = legacyArticleEntry(clean);
  return Boolean(entry && !entry.targetSlug);
}

export function verifiedTrArticleRedirect(pathname: string): string | null {
  const alias = legacyPathRedirect(pathname);
  if (/^\/(?:yazilar|essays)\//.test(pathname) && alias) return alias.to_url;
  const entry = legacyArticleEntry(pathname);
  return entry?.targetSlug ? `/yazilar/${entry.targetSlug}` : null;
}

/** Canonical English note redirects; stable content keys remain unchanged. */
/** Retired English concept slugs (previously listed in sitemaps/links) → current slug. */
const CONCEPT_ALIASES: Record<string, string> = {
  "epistemic-weaponisation": "epistemic-weaponization",
};

export function englishContentRedirect(pathname: string): string | null {
  const cm = pathname.match(/^\/concepts\/([^/]+)\/?$/);
  if (cm && CONCEPT_ALIASES[cm[1]]) return `/concepts/${CONCEPT_ALIASES[cm[1]]}`;
  const prefix = "/cop31-guide/notes/";
  if (!pathname.startsWith(prefix)) return null;
  const slug = pathname.slice(prefix.length).replace(/\/+$/, "");
  const note = getCop31Note(slug);
  if (!note) return null;
  const canonical = cop31NotePath(note.slug, "en");
  return pathname === canonical ? null : canonical;
}